/**
 * Created by fengqian_pc on 2018/1/15.
 */
export default {
  install(Vue, options) {
    Vue.filter('date', function (value) {
      function toDouble(val) {
        return val >= 10 ? val : '0' + val;
      }
      var date = new Date(value * 1000);

      var YY = date.getFullYear();
      var MM = toDouble(date.getMonth() + 1);
      var DD = toDouble(date.getDate());

      var hh = toDouble(date.getHours());
      var mm = toDouble(date.getMinutes());
      var ss = toDouble(date.getSeconds());

      if (value) {
        return YY + '/' + MM + '/' + DD;
      }
      return '';
    });
  },
};



// WEBPACK FOOTER //
// ./src/assets/js/filter.js